import React, { useEffect, useState } from 'react';
import { SearchIcon, Eye, Download, Plus, Calendar, CheckCircle, XCircle } from 'lucide-react';
import { Card, CardBody, Table } from 'reactstrap';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import MyPagination from '../pagination';
import { useLoader } from '../../_helper/LoaderContext';
import { getTransactionList, paymentPatient } from './service/ledger-service';
import { formatDoctorDisplayDate } from '../../utils/dateTime/dateFormat';
import { useCurrency } from '../../_helper/currencyContext';
import { Link } from 'react-router-dom';
import CurrencyAmountInput1 from '../CurrencyAmountInput1';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import { useLab } from '../../_helper/PharmacyProvider';
import { toast } from 'react-toastify';
import { FormLabel } from 'react-bootstrap';

export default function LadgerHome() {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [totalEntries, setTotalEntries] = useState(0);
  const { setLoading } = useLoader();
  const { getCurrencySymbol, convertCurrency, currency } = useCurrency();
  const [ledgerData, setLedgerData] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("Cash");
  const [show, setShow] = useState(false);
  const [settleLater, setSettleLater] = useState(false);
  const [payment, setPayment] = useState({});
  const [paidAmount, setPaidAmount] = useState("");
  const [total, setTotal] = useState("");
  const { currentLab } = useLab();
  const [currencyFor, setCurrencyFor] = useState("");
  const selectedCurrency = currencyFor || currentLab?.baseCurrency;
  const [outstanding, setOutstanding] = useState({});
  const [data, setData] = useState({});
  const [overpaymentConfirmed, setOverpaymentConfirmed] = useState(false);
  const totalInSelectedCurrency = convertCurrency(
    payment,
    currentLab?.baseCurrency,
    selectedCurrency
  );


  const paidInSelectedCurrency = (paidAmount || 0);
  const remainingInSelectedCurrency = totalInSelectedCurrency - paidInSelectedCurrency;

  useEffect(() => {
    getList()
  }, [currentPage, entriesPerPage, search])

  const getList = async () => {
    setLoading(true)
    try {
      const form_data = new FormData()
      form_data.append("search", search);
      form_data.append("page", currentPage);
      form_data.append("limit", entriesPerPage);
      const res = await getTransactionList(form_data)
      console.log(res)
      if (res.data.success == true) {
        // setLedgerData(res.data.data)
        // setTotalEntries(res.data.pagination.total || 0);
        setLedgerData(res.data.data.payments)
        setTotalEntries(res.data.data.total || 0);
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getList();
    }, 500); // waits 0.5s after typing stops

    return () => clearTimeout(delayDebounce);
  }, [search, currentPage, entriesPerPage]);

  const openPayment = (data) => {
    setShow(true)
    setPayment(data.balances[currentLab?.baseCurrency]);
    setPaidAmount(data.balances[currentLab?.baseCurrency].toFixed(2));
    setTotal(data.balances[currentLab?.baseCurrency].toFixed(2));
    setOutstanding(data.balances);
    setData(data)
  }

  const handleSettleLaterToggle = async () => {
    const willSettle = !settleLater;

    const result = await Swal.fire({
      title: willSettle
        ? "Are you sure?"
        : "Are you sure?",
      text: willSettle
        ? "Do you want to settle this payment?"
        : "Do you want to un-settle this payment?",
      icon: "info",
      showCancelButton: true,
      cancelButtonText: "No,Cancel",
      confirmButtonText: willSettle ? "Yes, Settle it!" : "Yes, Unsettle it!",
      reverseButtons: false,
    });

    if (result.isConfirmed) {
      setSettleLater(willSettle);
    }
  };

  // const paymentSubmit = async () => {
  //   let forcePaid = false;

  //   // 🔴 Overpayment check FIRST (no loader yet)
  //   if (paidAmount > total) {
  //     const result = await Swal.fire({
  //       title: 'Overpayment Detected',
  //       icon: 'warning',
  //       html: `
  //       <p>You are paying <strong>${getCurrencySymbol(selectedCurrency)}${paidAmount.toFixed(2)}</strong></p>
  //       <p class="text-danger mt-3 fw-bold">
  //         Extra amount: ${getCurrencySymbol(selectedCurrency)}${(paidAmount - total).toFixed(2)}
  //       </p>
  //     `,
  //       showCancelButton: true,
  //       confirmButtonText: 'Yes, Proceed Anyway',
  //       cancelButtonText: 'Cancel',
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       reverseButtons: true,
  //     });

  //     // ❌ User cancelled → stop here, no loader
  //     if (!result.isConfirmed) {
  //       return;
  //     }

  //     // ✔ User confirmed → continue
  //     forcePaid = true;
  //   }

  //   // 🔵 NOW start loading (only when API will be called)
  //   setLoading(true);

  //   try {
  //     const remaining = Number(remainingInSelectedCurrency?.toFixed(2)) || 0;

  //     const payload = {
  //       patientId: data.patientId,
  //       patientName: data.patientName,
  //       payingAmount: paidAmount,
  //       paymentType: paymentMethod,
  //       currency: currencyFor || currentLab?.baseCurrency,
  //       isPartial: !forcePaid && remaining > 0 && settleLater === false,
  //       isSettled: settleLater,
  //       rePayment: !settleLater,
  //       customerType: "walking",
  //     };

  //     // console.log(payload);

  //     const res = await paymentPatient(payload);
  //     if (res.data.success) {
  //       toast.success(res.data.message);
  //       setShow(false);
  //       getList();
  //     }

  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // const paymentSubmit = async () => {
  //   const paid = Number(paidAmount || 0);
  //   const totalDue = Number(remainingInSelectedCurrency?.toFixed(2)) || 0; // or 'total' if that's your variable
  //   const selectedCurrency = currencyFor || currentLab?.baseCurrency;

  //   let shouldProceed = true;

  //   // Overpayment check
  //   if (paid > totalDue + 0.01) { // +0.01 tolerance for floating point
  //     const result = await Swal.fire({
  //       title: 'Overpayment Detected',
  //       icon: 'warning',
  //       html: `
  //       <p>You are paying <strong>${getCurrencySymbol(selectedCurrency)}${paid.toFixed(2)}</strong></p>
  //       <p>Due amount: <strong>${getCurrencySymbol(selectedCurrency)}${totalDue.toFixed(2)}</strong></p>
  //       <p class="text-danger mt-3 fw-bold">
  //         Extra amount: ${getCurrencySymbol(selectedCurrency)}${(paid - totalDue).toFixed(2)}
  //       </p>
  //       <p class="mt-3">This will mark the bill as <strong>fully paid</strong>.</p>
  //     `,
  //       showCancelButton: true,
  //       confirmButtonText: 'Yes, Proceed',
  //       cancelButtonText: 'Cancel',
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       reverseButtons: true,
  //     });

  //     if (!result.isConfirmed) {
  //       shouldProceed = false;
  //       // Optional: reset any overpayment flag
  //       // setOverpaymentConfirmed(false);
  //     }
  //   }

  //   // If user cancelled overpayment → stop here
  //   if (!shouldProceed) {
  //     return; // Don't show loading or proceed
  //   }

  //   // NOW start loading — only after confirmation
  //   setLoading(true);

  //   try {
  //     const isFullyPaid = paid >= (totalDue - 0.01) || settleLater === true;

  //     const payload = {
  //       patientId: data.patientId,
  //       patientName: data.patientName,
  //       payingAmount: paid,
  //       paymentType: paymentMethod,
  //       currency: selectedCurrency,
  //       isPaid: isFullyPaid,
  //       isPartial: paid < totalDue && !settleLater,
  //       isSettled: settleLater || paid >= totalDue,
  //       rePayment: !settleLater,
  //       customerType: "walking",
  //     };

  //     console.log("Payload:", payload);

  //     const res = await paymentPatient(payload);

  //     if (res.data.success) {
  //       toast.success(res.data.message || "Payment recorded successfully!");
  //       setShow(false);
  //       getList();
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     toast.warning("Payment failed. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const paymentSubmit = async () => {
  let forcePaid = false;

  // Convert total due to the selected currency for accurate comparison
  const totalDueInSelected = totalInSelectedCurrency ?? 0;
  const paidInSelected = Number(paidAmount) || 0;

  // 🔴 Overpayment check: Compare paid vs due in the SAME (selected) currency
  if (paidInSelected > totalDueInSelected + 0.01) { // small tolerance for floating point
    const extraAmount = paidInSelected - totalDueInSelected;

    const result = await Swal.fire({
      title: 'Overpayment Detected',
      icon: 'warning',
      html: `
        <p>You are paying <strong>${getCurrencySymbol(selectedCurrency)}${paidInSelected.toFixed(2)}</strong></p>
        <p>Outstanding: <strong>${getCurrencySymbol(selectedCurrency)}${totalDueInSelected.toFixed(2)}</strong></p>
        <p class="text-danger mt-3 fw-bold">
          Extra amount: ${getCurrencySymbol(selectedCurrency)}${extraAmount.toFixed(2)}
        </p>
      `,
      showCancelButton: true,
      confirmButtonText: 'Yes, Proceed Anyway',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      reverseButtons: true,
    });

    if (!result.isConfirmed) {
      return; // User cancelled
    }

    forcePaid = true;
  }

  // 🔵 Now proceed with API call
  setLoading(true);

  try {
    const remaining = Number(remainingInSelectedCurrency?.toFixed(2)) || 0;

    // Your ORIGINAL payload — kept exactly as you wrote it
    const payload = {
      patientId: data.patientId,
      patientName: data.patientName,
      payingAmount: paidAmount,                    // ← as number/string from input
      paymentType: paymentMethod,
      currency: currencyFor || currentLab?.baseCurrency,
      isPartial: !forcePaid && remaining > 0 && settleLater === false,
      isSettled: settleLater,
      rePayment: !settleLater,
      customerType: "walking",
    };

    console.log("Payment Payload:", payload);

    const res = await paymentPatient(payload);

    if (res.data.success) {
      toast.success(res.data.message || "Payment recorded successfully!");
      setShow(false);
      setCurrencyFor(""); // optional: reset currency
      getList();
    } else {
      toast.warning(res.data.message || "Something went wrong.");
    }
  } catch (error) {
    console.error("Payment error:", error);
    toast.warning("Payment failed. Please try again.");
  } finally {
    setLoading(false);
  }
};
  const handlePageSizeChange = (e) => {
    const newSize = Number(e.target.value);
    setEntriesPerPage(newSize);  // Use the correct setter
    setCurrentPage(1);           // Reset to page 1
  }

  const getStartingSerialNumber = () => {
    return (currentPage - 1) * entriesPerPage + 1;
  };

  return (
    <>
      <Card>
        <div className="p-3 mt-4">
          <div className="tw-max-w-full tw-mx-auto">
            <div className="row mb-4 align-items-center">
              <div className="col-md-6">
                <div className="input-group">
                  <span className="input-group-text tw-bg-white" id="basic-addon1"><SearchIcon /></span>
                  <input type="text" className="form-control icon_form" placeholder="Search By Customer Name..." aria-label="Username" aria-describedby="basic-addon1" style={{ borderLeft: 'none' }} value={search} onChange={(e) => setSearch(e.target.value)} />
                </div>
              </div>
            </div>
            <CardBody>
              <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black"
              >
                <Table className="mb-0 table-center table-bordered table-hover" style={{ tableLayout: "fixed", overflowX: 'auto' }}>
                  <thead>
                    <tr>
                      <th className="text-center bg-primary tw-text-center" style={{
                        width: "80px"   // 👈 add width only to first column
                      }}>
                        <b>#</b>
                      </th>
                      <th className="bg-primary text-white text-left" style={{ width: '160px' }}><b>Customer Name</b></th>
                      {/* <th className="bg-primary text-white text-left" style={{ width: '10%' }}><b>Type</b></th> */}
                      <th className="bg-primary text-white text-left" style={{ width: '120px' }}><b>Total Amount</b></th>
                      <th className="bg-primary text-white" style={{ width: '100px' }}><b>Paid</b></th>
                      {/* <th className="bg-primary text-white" style={{ width: '100px' }}><b>Currency</b></th> */}

                      {/* ⭐ NEW TOTAL COLUMN */}
                      <th className="bg-primary text-white" style={{ width: '180px' }}><b>Outstanding Balance</b></th>

                      <th className="bg-primary text-white" style={{ width: '100px' }}><b>Status</b></th>
                      <th className="bg-primary text-white" style={{ width: '120px' }}><b>Date</b></th>
                      <th className="bg-primary text-white text-center" style={{ width: '100px' }}><b>Action</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    {ledgerData.length > 0 ? (
                      ledgerData.map((item, index) => {
                        const serialNumber = getStartingSerialNumber() + index;
                        return (
                          <tr key={item.id} className={index % 2 === 0 ? '' : ''}>
                            <td className="text-center font-weight-bold">
                              {serialNumber}
                            </td>
                            <td className=" tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              <div
                                className="tw-font-medium tw-ps-3"
                              >
                                {item.patientName}
                              </div>

                            </td>
                            <td className='fw-bold'>
                              {item.netTotal > 0 ? (
                                <>
                                  {getCurrencySymbol(item.currency)}{item.netTotal?.toFixed(2)}
                                </>
                              ) : (
                                <>-</>
                              )}
                            </td>
                            <td className='fw-bold text-success'>
                              {getCurrencySymbol(item.currency)}{item.amount?.toFixed(2)}
                            </td>
                            {/* <td>
                              <div className="fw-bold"> {item.currency}</div>
                            </td> */}
                            <td className="fw-bold">
                              {item.currency &&
                                item.balances &&
                                Object.keys(item.balances).length > 0 &&
                                item.balances[item.currency] !== undefined
                                ? `${getCurrencySymbol(item.currency)}${Number(item.balances[item.currency]).toFixed(2)}`
                                : "0"
                              }
                            </td>

                            <td>
                              {item.isSettled ? (
                                <span className="badge bg-success">Settled</span>
                              ) : (
                                <>
                                  {item.isPaid && (
                                    <span className="badge bg-primary">Paid</span>
                                  )}
                                  {item.isPartialPaid && (
                                    <span className="badge bg-warning text-dark">Partial Paid</span>
                                  )}
                                  {!item.isPaid && !item.isSettled && !item.isPartialPaid && (
                                    <span className="badge bg-primary">Payment</span>
                                  )}
                                </>
                              )}

                            </td>
                            <td>
                              {formatDoctorDisplayDate(item.createdAt, currentLab) || "-"}
                            </td>

                            <td className="tw-px-4 tw-py-4 text-center">
                              <div className="">
                                {item.balances.INR > 0.01 && (
                                  <>
                                    <Tooltip id="pay" place="top" content="Pay" />
                                    <button
                                      className='success-action-button me-1'
                                      data-tooltip-id="pay"
                                      onClick={() => openPayment(item)}
                                    >
                                      <i className="fa fa-money" style={{ fontSize: "18px" }}></i>
                                    </button>
                                  </>
                                )}
                                <Tooltip id="invoice" place="top" content="View Invoice" />
                                <Link to={`${process.env.PUBLIC_URL}/view-transaction/${item.patientId}`}>
                                  <button className='success-action-button me-1' data-tooltip-id="invoice">
                                    <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                                  </button>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        )
                      }
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={8}
                          className="text-center py-4 text-muted"
                        >
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </CardBody>
            <div className="d-md-flex align-items-center text-center justify-content-between">
              <div className="show-entries">

                <FormLabel>{t("Show")}&nbsp;</FormLabel>
                <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
                  onChange={handlePageSizeChange} className="form-control">
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={30}>30</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>&nbsp;
                <FormLabel>{t("entries")}</FormLabel>
              </div>
              <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
            </div>
            {/* <div className="mt-3">
              <MyPagination totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}></MyPagination>
            </div> */}
          </div>
        </div>
      </Card>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton style={{ backgroundColor: "#dbffe5" }}>
          <Modal.Title> <i className="fa fa-money me-2"></i> Process Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-3">
            {/* Payment Method */}
            <div className="col-12">
              <label>Payment Method</label>
              <select className="form-select" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                <option>Cash</option>
                <option>Card</option>
                <option>UPI</option>
              </select>
            </div>

            <div className="col-md-12">
              <div className="p-3 rounded border border-success">
                <div className="tw-font-bold">Outstanding Balances:</div>
                <div className="mt-1">
                  {Object.entries(outstanding).map(([currency, value]) => (
                    <div
                      key={currency}
                      className="d-flex justify-content-between mb-1"
                      style={{ fontSize: "15px" }}>
                      <span>{currency}</span>
                      <span className='tw-font-bold'> {getCurrencySymbol(currency)}{value?.toFixed(2)}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Currency Amount Input */}
            <div className="col-12">
              <CurrencyAmountInput1
                label="Paid Amount"
                amount={paidAmount}
                onAmountChange={(value) => {
                  setPaidAmount(value);
                }}
                onCurrencyChange={(currency) => {
                  setCurrencyFor(currency)
                }}
              />
            </div>
            {remainingInSelectedCurrency?.toFixed(2) > 0 && (
              <div className="col-md-12">
                <div className="p-3 rounded border border-success text-danger" style={{ backgroundColor: "#f8fff9" }}>
                  Remaining:  {getCurrencySymbol(selectedCurrency)}  {Number(remainingInSelectedCurrency?.toFixed(2))}
                </div>
              </div>
            )}

            <div className="col-12 mt-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="settleLater"
                  checked={settleLater}
                  onChange={handleSettleLaterToggle}
                />
                <label className="form-check-label fw-bold" htmlFor="settleLater">
                  Payment Settlement
                </label>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={paymentSubmit}>
            Pay
          </button>
          <button className="btn btn-secondary" onClick={() => {
            setShow(false)
            setCurrencyFor("")
          }}>Cancel</button>
        </Modal.Footer>
      </Modal>

    </>
  )
}
